<template>
    <div class="wizard-progress">
        <p class="wizard-progress-time">
            Noch ca. <em>{{ getTime }} min</em> bis Ihre Webseite fertig ist
        </p>

        <div class="wizard-progress-bar">
            <div
                v-for="n in page"
                :key="'done' + n"
                :class="
                    'wizard-progress-bar__done wizard-progress-bar__done--' +
                        (n - 1) +
                        ' wizard-progress-bar__done--total-' +
                        pageMax
                "
            >
                Seite {{ n }}
            </div>
            <div
                v-for="n in pageMax - page"
                :key="'notDone' + n"
                class="wizard-progress-bar__not-done"
            >
                Seite {{ page + n }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pageMax: 18,
            minPerPage: 1
        };
    },
    components: {},
    methods: {},
    computed: {
        getTime() {
            return (this.pageMax - this.page) * this.minPerPage;
        }
    },
    created() {},
    mounted() {},
    props: {
        page: Number
    }
};
</script>
